import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { DetalheComponent } from './components/detalhe/detalhe.component';
import { PermissoesComponent } from './components/permissoes/permissoes.component';
import { SolicitacoesComponent } from './components/solicitacoes/solicitacoes.component';
import { GerenciarCredenciaisComponent } from './components/gerenciar-credenciais/gerenciar-credenciais.component';
import { LoginComponent } from './components/login/login.component';
import { SolicitacaoDeAcessoComponent } from './components/solicitacao-de-acesso/solicitacao-de-acesso.component';
import { TermosDeUsoComponent } from './components/termos-de-uso/termos-de-uso.component';
import { ResumoSolicitacaoComponent } from './components/resumo-solicitacao/resumo-solicitacao.component';
import {DownloadCsvComponent} from './components/download-csv/download-csv.component';
import {CpfLiberadoCsvComponent} from './components/cpf-liberado-csv/cpf-liberado-csv.component';
import {ArquivoCsvComponent} from './components/arquivo-csv/arquivo-csv.component';
import {FederalizacaoComponent} from './components/federalizacao/federalizacao.component';
import {HomeRedirectGuard} from './guards/home-redirect.guard';


const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full'},
  { path: '', component: HomeComponent, canActivate: [HomeRedirectGuard]},
  { path: 'detalhe/:id', component: DetalheComponent },
  { path: 'permissoes', component: PermissoesComponent },
  { path: 'solicitacoes', component: SolicitacoesComponent },
  { path: 'gerenciar-credenciais', component: GerenciarCredenciaisComponent },
  { path: 'download-csv', component: DownloadCsvComponent },
  { path: 'federalizacao', component: FederalizacaoComponent },
  { path: 'cpf-liberado-csv/:solicitacao/:nuSolicitacao', component: CpfLiberadoCsvComponent },
  { path: 'arquivo-csv/:idPortifolio/:permissao', component: ArquivoCsvComponent },
  { path: 'login', component: LoginComponent },
  { path: 'solicitacao-de-acesso', component: SolicitacaoDeAcessoComponent },
  { path: 'termos-de-uso', component: TermosDeUsoComponent },
  { path: 'resumo-solicitacao', component: ResumoSolicitacaoComponent },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts